<div [ngSwitch]="getLoaderType()">
    <div *ngSwitchCase="'clearview'" [ngClass]="{ 'whiteOverlay fadeInOverlay': overlay, 'loadViewArea': isFullScreen }">
        <div class="ng-loader-container" [ngClass]="sizeClass">
            <mat-progress-spinner class="track" [diameter]="sizePixels" [mode]="'determinate'" [value]="100" ></mat-progress-spinner>
            <mat-progress-spinner class="loader" [ngClass]="sizeClass" [diameter]="sizePixels" [mode]="'indeterminate'"></mat-progress-spinner>
        </div>
    </div>
</div>
